import { __assign, __generator } from "tslib";
import { request } from '../../xhr';
import { put, call } from 'redux-saga/effects';
import { galleryFolderSchema, collectionFolderSchema, } from '../../redux/normalizr/schemas/folder';
import { normalize } from '../../redux/normalizr';
import { putEntities } from '../../redux/entities/actions';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
function setGallectionCover(_a) {
    var updatedGallection, gallectionSchema, entities, params;
    var gallection = _a.gallection, deviation = _a.deviation, _b = _a.onlyIfMissing, onlyIfMissing = _b === void 0 ? false : _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (onlyIfMissing && gallection.thumb) {
                    return [2 /*return*/];
                }
                if (![DeviationTypes.IMAGE, DeviationTypes.LITERATURE].includes(getDeviationType(deviation))) {
                    // Only allow images and literature deviations as gallection covers
                    return [2 /*return*/];
                }
                updatedGallection = __assign(__assign({}, gallection), { thumb: deviation.deviationId });
                gallectionSchema = gallection.type === 'gallery'
                    ? galleryFolderSchema
                    : collectionFolderSchema;
                entities = normalize(updatedGallection, gallectionSchema).entities;
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 1:
                _c.sent();
                params = {
                    type: gallection.type,
                    folderid: gallection.folderId,
                    name: gallection.name,
                    description: gallection.description || '',
                    cover_deviationid: deviation.deviationId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/update',
                        data: params,
                    })];
            case 2:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export function setGallectionCoverActionHandler(action) {
    var _a, gallection, deviation, entities;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, gallection = _a.gallection, deviation = _a.deviation;
                return [4 /*yield*/, call(setGallectionCover, {
                        gallection: gallection,
                        deviation: deviation,
                    })];
            case 1:
                _b.sent();
                entities = normalize(deviation, deviationSchema).entities;
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default setGallectionCover;
//# sourceMappingURL=setGallectionCover.js.map